export const enum RegisterInbound {
	GridClickGeneratorCard = 'click_first_generator_card',
	NavigationClickGeneratorLink = 'navigate_to_create',
	HeaderClickAction = 'click_create_account_header',
	LoginModalSwitchToCreate = 'click_create_account_modal',
	GenerateCharacter = 'attempt_to_generate_character',

	ChatClickLockedBot = 'attempt_chat_locked_level',
	ChatSendMessage = 'attempt_send_message',
	ChatSendGift = 'attempt_send_gift',
	ChatClickTopic = 'attempt_click_topic',
	GenerateImage = 'attempt_to_create_second_image',
	GenerateImagePaidOption = 'attempt_to_choose_paid_option',

	ChatSendMessageUDC = 'attempt_send_message_ugcbot',
	ChatSendGiftUDC = 'attempt_send_gift_ugcbot',
	ChatClickTopicUDC = 'attempt_click_topic_ugcbot',

	HeaderNsfwAction = 'click_change_mode_header',
	GridNsfwSearchSwitch = 'click_change_mode_grid',
	ChatNsfwContactsSwitch = 'click_change_mode_chat',

	NoneIdentified = 'none_identified',
	PaywallOpen = 'attempt_open_paywall',

	LikeMediaGen = 'like_mediagen',
	LikeGallery = 'like_gallery',
	LikeCreatorProfile = 'like_creator_profile',
	LikeSingleMediaPage = 'like_single_media_page',
}

export const enum RegisterOutbound {
	GeneratorBot = 'g_tool_bot_generation',
	GeneratorImages = 'g_tool_image_generation',
	Chat = 'chat',
	Grid = 'grid',
	NoneIdentified = 'none_identified',
}
